import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { LabellingSamples } from "./labelling-samples.entity";
@Entity('labelling')
export class Labelling {
    @PrimaryGeneratedColumn('increment', {
        name: 'labelling_id',
    })
    labellingId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "lot_number",
        
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "labelling_code",
        default: 'generatedCode'
    })
    labellingCode: string;

    @Column('int', {
        name: 'saleOrder_Id'
    })
    saleOrderId: number

    @Column('int', {
        name: 'saleorder_item_id'
    })
    saleOrderItemId: number


    @Column({
        nullable: true,
        name: 'labelling_date',
    })
    labellingDate: Date;

    @Column('varchar', {
        nullable: false,
        name: 'traceability_code',
    })
    traceabilityCode: string;


    @Column('varchar', {
        nullable: false,
        name: 'country',
    })
    country: string;

    @Column('varchar', {
        nullable: false,
        name: 'totalMCs',
    })
    totalMCs: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => LabellingSamples, samples => samples.labellingInfo, { cascade: true })
    labellingSamplesInfo: LabellingSamples[];
}